import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Container, InputGroup, Form, Button } from 'react-bootstrap'
import { errorMessage } from '../../constants/errorMessage'
import qrcode from '../../assets/img/qr-code.png'
// import ScanQr from './ScanQr'
import { Circles } from 'react-loader-spinner'
import { applyReservationId } from '../../redux/actions/transientAction'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import UploadQr from '../../global/ScanQrCode/UploadQr'
import CONSTANTS from '../../redux/constants'
import { addEventLog } from '../../redux/actions/EventsLog'

function ReservationWithID(props) {
    const { dispatch, toggle, setFaciltyData, faciltyData, setTotalHoursLength, setReservationData, reservationData, notify } = props
    const [reservationID, setreservationID] = useState('')
    const [isPromoCodeAppiled, setIsPromoCodeApplied] = useState(false)
    const [scanResult, setScanResult] = useState(null)
    const [isScanDisplay, setIsScanDisplay] = useState(false)
    const [message, setMessage] = useState('')
    const [isError, setIsError] = useState(false)
    const [isApplyReservation, setIsApplyReservation] = useState(false)

    const handleReservation = (e) => {
        e.preventDefault()
        const { value } = e.target
        setreservationID(value?.toUpperCase())
        setIsError(false)
        setMessage('')
        // if (value == '') {
        //     handleResetReservationID()
        // }
    }

    useEffect(() => {
        if(scanResult && scanResult !== 'No Qr') {
            setreservationID(scanResult)
        }
        if (scanResult && reservationID !== '' && scanResult !== 'No Qr') {
            handleSubmitReservationID()
        }
        if(scanResult === 'No Qr') {
            setIsError(true)
            setMessage('Please enter a Reservation ID')
        }
    }, [scanResult, reservationID])

    // useEffect(() => {
    //     handleResetReservationID()
    // }, [length])

    // useEffect(() => {
    //     if (ticketDetails?.promocode && ticketDetails?.promocode != '') {
    //         setIsPromoCodeApplied(true)
    //         setPromoCode(ticketDetails?.promocode)
    //         setMessage(`${ticketDetails?.promocode} applied`)
    //     }

    // }, [])

    // const handleResetReservationID = () => {
    //     console.log('reset Reservation ID')
    // }

    const handleSubmitReservationID = () => {
        setIsApplyReservation(true)
        if (reservationID !== '' && reservationID !== null) {
            const facilityData = JSON.parse(localStorage.getItem('faclityData'))
            const finalPayload = {
                reservation_id: reservationID,
                facility_id : facilityData?.facility?.id
            }

            dispatch(applyReservationId(finalPayload)).then((res) => {
                setIsPromoCodeApplied(true)
                if (res?.data) {
                    let facility = {...faciltyData, valid_till: res?.data?.end_time?.date}
                    let localFacility = JSON.parse(localStorage.getItem('faclityData'))
                    localStorage.setItem('faclityData', JSON.stringify(localFacility))
                    setFaciltyData(facility)
                    setTotalHoursLength(res?.data?.length)
                    setReservationData({ ...reservationData, reservationID: reservationID, license_plate: res?.data?.license_plate })
                    toggle()
                } else {
                    // notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsApplyReservation(false)
                    setIsPromoCodeApplied(false)
                    // setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsError(true)
                    setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setreservationID('')
                    setScanResult(null)
                    let errObject = { 
                        payload: finalPayload,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong  
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} applyReservationId-ReservationWithID.js-74`))
                }
            }).catch((err) => {
                let errObject = { 
                    payload: finalPayload,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong  
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} applyReservationId-ReservationWithID.js-74`))
                // notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                setIsApplyReservation(false)
                setIsPromoCodeApplied(false)
                // setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                setIsError(true)
                setreservationID('')
                setScanResult(null)
                setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            })

        } else {
            setIsApplyReservation(false)
            setIsError(true)
            setMessage('Please enter a Reservation ID')
        }

    }

    const handleQrScan = () => {
        setIsScanDisplay(true)
    }
    return (
        <div>
            <Container className='mb-3 mt-3'>
                {/* <Form.Label className='text-info styleLables'>Promo Code</Form.Label> */}
                <InputGroup className=" myiconset border rounded d-flex justify-content-center align-items-center">
                    <Form.Control className='border-0' placeholder="Enter Reservation ID" aria-label="reservationID" aria-describedby="basic-addon2" value={reservationID} onChange={handleReservation} />

                    <Button disabled={isApplyReservation} className='border-0' variant=" text-primary" type='button' id="button-addon2" onClick={handleSubmitReservationID}>
                        <div className='d-flex'>
                            <span className='me-2'>Search</span>
                            {isApplyReservation ?

                                <Circles
                                    height="20"
                                    width="20"
                                    style={{ display: 'inline-block' }}
                                    color="var(--bs-primary)"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /> : ''}
                        </div>

                    </Button>
                    <img src={qrcode} className='me-2 qr-img' alt="Scan QR for Code" onClick={() => handleQrScan()} />
                </InputGroup>
                <span className={isError ? 'text-danger small text-left mt-1' : 'text-success small text-left mt-1'}>{isPromoCodeAppiled ? <i className='me-1 fa fa-check-circle'></i> : ''}{message}</span>
            </Container>
            {isScanDisplay && <div className='zIndexHigh top-0 position-fixed scanner_Wrap' style={{width: '100vw', left: '0', backgroundColor: '#fff'}}>
                {/* <ScanQr clasName='h-100' setScanResult={setScanResult} scanResult={scanResult} setIsScanDisplay={setIsScanDisplay} /> */}
                <div className='m-auto' style={{maxWidth: '400px'}}>
                    <UploadQr setScanResult={setScanResult} scanResult={scanResult} setIsScanDisplay={setIsScanDisplay} notify={notify} />
                </div>
            </div>}
        </div>
    )
}

ReservationWithID.propTypes = {
    dispatch: PropTypes.func,
    toggle: PropTypes.func,
    setFaciltyData: PropTypes.func,
    setTotalHoursLength: PropTypes.func,
    setReservationData: PropTypes.func,
    notify: PropTypes.func,
    faciltyData: PropTypes.object,
    reservationData: PropTypes.object,
}

ReservationWithID.defaulProps = {
    dispatch: noop,
    toggle: noop,
    setFaciltyData: noop,
    setTotalHoursLength: noop,
    setReservationData: noop,
    notify: noop,
    faciltyData: EMPTY_OBJECT,
    reservationData: EMPTY_OBJECT,
}

function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(ReservationWithID)